<template>
  <div class="forum">
    <div class="forum-box">
      <div class="left">
        <template v-if="group.length>0">
          <p class="title">
            <span>热门小组</span>
            <router-link class="more" :to="{ name: 'CommunityGroup' }">查看更多</router-link>
          </p>
          <div class="group">
            <el-row :gutter="42">
              <el-col :span="8" v-for="item in group" :key="item.id">
                <router-link
                  class="grid-content"
                  :to="{ name: 'CommunityGroupShow', params: { id: item.id } }"
                >
                  <div class="img-wrap">
                    <img class="img" :src="item.image" @load="onGroupImageLoad" />
                  </div>
                  <div class="content">
                    <p class="name eps">{{ item.name }}</p>
                    <div class="message">
                      <p class="people">
                        <span>{{ item.user_num }}</span>
                      </p>
                      <p class="comment">
                        <span>{{ item.post_num }}</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </el-col>
            </el-row>
          </div>
        </template>
        <div class="bbs-box">
          <el-tabs class="el-tabs-custom" v-model="activeName" @tab-click="hotNewChange()">
            <el-tab-pane label="热门贴" name="1"></el-tab-pane>
            <el-tab-pane label="最新贴" name="2"></el-tab-pane>
          </el-tabs>
          <ul class="forum-list">
            <CommunityItem
              v-for="item in topicList"
              :key="item.id"
              :item="item"
              @complaint="onComplaint(item)"
              @delete="getTopicList"
            ></CommunityItem>
          </ul>
          <Empty v-if="topicList.length == 0" class="empty" title="暂无帖子！" />
          <el-pagination
            v-if="topicList.length > 0"
            background
            layout="prev, pager, next"
            @current-change="handle_current_change"
            :page-size="limit"
            :current-page="page"
            :total="totalPage"
          ></el-pagination>
        </div>
      </div>
      <div class="right">
        <div class="look-day">
          <div class="today">
            <p class="num">{{ topicCount.today_post_num }}</p>
            <p class="day">今日贴数</p>
          </div>
          <div>
            <p class="num">{{ topicCount.yesterday_post_num }}</p>
            <p class="day">昨日贴数</p>
          </div>
        </div>
        <div class="mine m-group">
          <p @click="toMemberCommunity('3')" class="title">
            我的小组
            <i></i>
          </p>
          <router-link v-if="!$store.state.token" class="no-login" :to="{ name: 'Login' }">登录后才能查看哦～</router-link>
          <div v-else class="login">
            <router-link
              v-for="item in myGroup"
              :key="item.group_id"
              class="grid-content"
              :to="{ name: 'CommunityGroupShow', params: { id: item.id } }"
            >
              <div class="img">
                <img :src="item.image" />
              </div>
              <div class="content">
                <p class="name">{{ item.name }}</p>
                <div class="message">
                  <p class="people">
                    <span>{{ item.user_num }}</span>
                  </p>
                  <p class="comment">
                    <span>{{ item.post_num }}</span>
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="mine m-collect">
          <p @click="toMemberCommunity('2')" class="title">
            我的收藏
            <i></i>
          </p>
          <router-link v-if="!$store.state.token" class="no-login" :to="{ name: 'Login' }">登录后才能查看哦～</router-link>
          <div v-else class="list">
            <router-link
              class="eps"
              v-for="(item, index) in myCollect"
              :key="index"
              :to="{
                name: 'CommunityShow',
                params: { id: item.post_id },
                query: { group_id: item.group_id }
              }"
            >{{ index + 1 }}、{{ item.title }}</router-link>
          </div>
        </div>
        <div class="mine m-post">
          <p @click="toMemberCommunity()" class="title">
            我的帖子
            <i></i>
          </p>
          <router-link v-if="!$store.state.token" class="no-login" :to="{ name: 'Login' }">登录后才能查看哦～</router-link>
          <div v-else class="list">
            <router-link
              class="eps"
              v-for="(item, index) in myPost"
              :key="index"
              :to="{
                name: 'CommunityShow',
                params: { id: item.post_id },
                query: { group_id: item.group_id }
              }"
            >{{ index + 1 }}、{{ item.title }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <Complaint ref="complaint"></Complaint>
  </div>
</template>

<script>
import CommunityItem from "../../components/CommunityItem";
import Complaint from "../../components/Complaint.vue";
export default {
  name: "Course",
  components: { CommunityItem, Complaint },
  data() {
    return {
      activeName: "1", //话题类型
      group: [], //获取小组列表
      topicCount: {}, //总发帖量
      topicList: [], //话题列表
      myGroup: [], //我的小组
      myPost: [], //我的参与
      myCollect: [], //我的收藏
      totalPage: 0, //数据总数
      page: 1, //当前分页
      limit: 10 //分页限制
    };
  },
  async created() {
    await this.getGroupList();
    await this.getTopicList();
    await this.getPostNum();
    if (this.$store.state.token) {
      await this.getMineGroup();
      await this.getMinePost();
      await this.getMineCollect();
    }
  },
  mounted: function() {},
  methods: {
    // 获取小组列表
    async getGroupList() {
      const that = this;
      let data = await that.$http.get("/api/app/community/group", {
        limit: 6,
        is_hot: 1
      });
      that.group = data.list.splice(0, 6);
    },

    // 热门最新话题切换
    async hotNewChange() {
      this.page = 1;
      this.getTopicList();
    },

    // 获取话题列表
    async getTopicList() {
      const that = this;
      let data = await that.$http.get("/api/app/community/post?", {
        order: "desc",
        order_by: that.activeName == 1 ? "click_num" : "",
        page: that.page,
        limit: that.limit
      });
      that.topicList = data.list;
      that.totalPage = data.total;
    },

    // 分页加载数据
    handle_current_change(val) {
      this.page = val;
      this.getTopicList();
    },

    // 获取发布数量
    async getPostNum() {
      const that = this;
      let data = await that.$http.get("/api/app/community/post/statistics");
      that.topicCount = data;
    },

    // 获取我的小组
    async getMineGroup() {
      const that = this;
      let data = await that.$http.get("/api/app/community/group/myGroup");
      that.myGroup = data.list.slice(0, 4);
    },

    // 获取我的帖子
    async getMinePost(limit) {
      const that = this;
      let data = await that.$http.get("/api/app/community/myPost", {
        page: 1,
        limit: limit ? limit : 5
      });
      that.myPost = data.list;
    },

    // 我的收藏
    async getMineCollect() {
      let data = await this.$http.get("/api/app/collect", {
        type: 6
      });
      this.myCollect = data.list;
    },
    // 跳转
    toMemberCommunity(tab) {
      if (this.$store.state.token) {
        this.$router.push({
          name: "MemberCommunity",
          query: {
            tab
          }
        });
      } else {
        this.$router.push({
          name: "Login"
        });
      }
    },
    onGroupImageLoad($event) {
      let width = $event.target.naturalWidth;
      let height = $event.target.naturalHeight;
      if (width < 72 || height < 72) {
        return;
      }
      let widthPercent = 72 / width;
      let heightPercent = 72 / height;
      let percent = widthPercent > heightPercent ? widthPercent : heightPercent;
      width = parseInt(width * percent);
      height = parseInt(height * percent);
      $event.target.style.width = width + "px";
      $event.target.style.height = height + "px";
    },
    onComplaint(item) {
      this.$refs.complaint.show(4, item.id);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.forum {
  padding-bottom: 60px;
  overflow: hidden;
  /deep/ {
    .el-pagination {
      margin: 25px 0;
    }
    .el-tabs__nav-scroll {
      padding-left: 25px;
      padding-top: 12px;
    }
    .el-tabs__nav-wrap::after {
      background-color: #e6e6e6;
    }
  }
  .forum-box {
    overflow: hidden;
    width: 1200px;
    margin: 30px auto 0;
    .left {
      float: left;
      width: 830px;
      border-radius: 5px;
      overflow: hidden;
      .title {
        display: flex;
        justify-content: space-between;
        height: 30px;
        line-height: 30px;
        span {
          font-size: 22px;
          font-family: PingFangSC-Medium;
          color: #20242a;
        }
        a {
          padding-right: 11px;
          background: url("~@/assets/images/icon_fourm_right_arrow.png") right
            9px no-repeat;
          background-size: 6px 11px;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          color: #5b6066;
        }
      }
      .group {
        margin: 15px 0 6px;
        .el-row {
          margin: 0 !important;
        }
        .el-col {
          margin-bottom: 28px;
          padding: 0 !important;
          margin-right: 94px;
          width: auto !important;
          &:nth-child(3n) {
            margin-right: 0;
          }
          .grid-content {
            width: 213px;
            height: 112px;
            box-sizing: border-box;
            position: relative;
            top: 0;
            padding: 18px 15px 19px 15px;
            border-radius: 10px;
            background: url("~@/assets/images/icon_forum_group_bg.png") center
              no-repeat;
            background-size: 100% 100%;
            box-shadow: 0 6px 20px 0 $primary-color-04,
              0px 13px 33px 0 rgba(0, 0, 0, 0.04);
            transition: top 0.3s;
            overflow: hidden;
            display: flex;
            align-items: center;
            .img-wrap {
              float: left;
              width: 72px;
              height: 72px;
              border-radius: 10px;
              overflow: hidden;
              flex-shrink: 0;
            }
            .img {
              border-radius: 10px;
            }
            .content {
              float: left;
              margin-left: 15px;
              width: auto;
              overflow: hidden;
              .name {
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(32, 36, 42, 1);
                line-height: 22px;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-bottom: 38px;
              }
              .message {
                display: flex;
                font-size: 12px;
                color: #8c8c8c;
                .people {
                  margin-right: 41px;
                  padding-left: 17px;
                  background: url("~@/assets/images/icon_fourm_people.png") left
                    center no-repeat;
                  background-size: 12px 10px;
                }
                .comment {
                  padding-left: 14px;
                  background: url("~@/assets/images/icon_fourm_edit.png") left
                    center no-repeat;
                  background-size: 9px 10px;
                }
              }
            }
            .btn {
              position: absolute;
              left: 50%;
              bottom: -13px;
              display: none;
              width: 66px;
              height: 26px;
              margin-left: -33px;
              border-radius: 14px;
              background-color: $primary-color;
              text-align: center;
              font-size: 13px;
              color: #fff;
              line-height: 26px;
            }
            &:hover {
              top: -10px;
            }
          }
        }
      }
      .bbs-box {
        background-color: #fff;
        overflow: hidden;
        .forum-list {
          padding: 0 25px;
          box-sizing: border-box;
        }
      }
    }
    .right {
      margin-left: 860px;
      width: auto;
      .look-day {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 135px;
        background: #fff;
        border-radius: 5px;
        div {
          flex: 1;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        .today {
          position: relative;
          &::after {
            content: "";
            width: 1px;
            height: 40px;
            background-color: #edf1f2;
            position: absolute;
            right: 0;
            top: 47px;
          }
        }
        .num {
          margin: 0 0 15px;
          font-size: 30px;
          font-family: PingFangSC-Medium;
          color: #20242a;
          line-height: 30px;
        }
        .day {
          line-height: 16px;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          color: #b7b7b7;
        }
      }
      .post {
        display: block;
        width: 100%;
        margin: 20px 0 0;
        padding: 0 0 0 130px;
        height: 60px;
        line-height: 60px;
        border: none;
        box-shadow: 0px 6px 20px 0px $primary-color-04,
          0px 13px 33px 0px rgba(0, 0, 0, 0.04);
        border-radius: 32px;
        background: url("~@/assets/images/icon_fourm_post.png") 180px center
          no-repeat #fff;
        background-size: 18px 18px;
        text-align: left;
        font-size: 20px;
        color: #595959;
        outline: none;
        cursor: pointer;
        &:hover {
          background: url("~@/assets/images/icon_fourm_post_active.png") 180px
            center no-repeat $primary-color;
          background-size: 18px 18px;
          color: #fff;
        }
      }
      .mine {
        margin-top: 20px;
        padding: 0 20px;
        background-color: #fff;
        border-radius: 5px;
        .title {
          position: relative;
          padding: 0 20px;
          height: 50px;
          border-bottom: 1px solid #edf1f2;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          color: #5b6066;
          line-height: 50px;
          cursor: pointer;
          i {
            position: absolute;
            top: 20px;
            right: 0;
            display: block;
            width: 6px;
            height: 11px;
            background: url("~@/assets/images/icon_fourm_right_arrow.png")
              center no-repeat;
            background-size: 100% 100%;
          }
        }
        .no-login {
          display: block;
          height: 220px;
          background: url("~@/assets/images/fourm_no_login_bg.png") center
            no-repeat #fff;
          background-size: 200px 100px;
          line-height: 320px;
          text-align: center;
          font-size: 17px;
          color: #20242a;
        }
        .list {
          a {
            display: block;
            margin: 15px 0;
            line-height: 14px;
            font-size: 14px;
            color: #333;
          }
        }
      }
      .m-group {
        overflow: hidden;
        .title {
          background: url("~@/assets/images/icon_fourm_title_group.png") left
            center no-repeat;
          background-size: 16px 14px;
        }
        .grid-content {
          display: flex;
          margin: 20px 0;
          .img {
            width: 70px;
            height: 70px;
            img {
              display: block;
              width: 70px;
              height: 70px;
              border-radius: 10px;
            }
          }
          .content {
            margin-left: 15px;
            flex: 1;
            .name {
              height: 44px;
              line-height: 22px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 16px;
              font-family: PingFangSC-Medium;
              color: #20242a;
            }
            .message {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              margin-top: 12px;
              font-size: 12px;
              color: #8c8c8c;
              line-height: 12px;
              .people {
                padding-left: 17px;
                background: url("~@/assets/images/icon_fourm_people.png") left
                  center no-repeat;
                background-size: 12px 10px;
              }
              .comment {
                margin-left: 30px;
                padding-left: 14px;
                background: url("~@/assets/images/icon_fourm_edit.png") left
                  center no-repeat;
                background-size: 9px 10px;
              }
            }
          }
        }
      }
      .m-collect {
        overflow: hidden;
        .title {
          background: url("~@/assets/images/icon_fourm_title_collect.png") left
            center no-repeat;
          background-size: 15px 14px;
        }
      }
      .m-post {
        overflow: hidden;
        .title {
          background: url("~@/assets/images/icon_fourm_title_post.png") left
            center no-repeat;
          background-size: 15px 14px;
        }
      }
    }
  }
}
</style>
